module.exports = __webpack_public_path__ + "img/icon-qzone.df815d75.png";